/**
 * 一般商品
 * @type {string}
 */
export const GOODS_TYPE_GENERAL_GOODS = "GENERAL_GOODS";

/**
 * 嘟电影
 * @type {string}
 */
export const GOODS_TYPE_DU_MOVIE = "DU_MOVIE";

/**
 *电子卡券
 * @type {string}
 */
export const GOODS_TYPE_TICKET = "TICKET";

/**
 *演出门票
 * @type {string}
 */
export const GOODS_TYPE_DU_DRAMA = "DU_DRAMA";

/**
 *旅游门票
 * @type {string}
 */
export const GOODS_TYPE_TRAVEL = "TRAVEL";

export const GOODS_TYPE_BOOK = "BOOK";

/**
 * 线下订单
 * @type {string}
 */
export const GOODS_TYPE_OFFLINE = "OFFLINE";

export const ORDER_TYPE_HEALTH = "health";

export const ORDER_TYPE_TRAVEL = "travel";

export const ORDER_TYPE_HW_H5 = "HW_H5";

export const ORDER_TYPE_JDJL = "JDJL";

export const ORDER_TYPE_YHCS = "YHCS";

export const ORDER_TYPE_WDG = "WDG";

/**
 * 商品固定标签
 * @type {{new: string, sale: string, top: string, recommend: string, hot: string}}
 */
export const GOODS_TAGS = {
  hot: "热销",
  new: "新品",
  top: "优选",
  recommend: "推荐",
  sale: "促销",
};

/**
 * 商品类别编号
 * @type {{general: number, movie: number, ticket: number, cake: number, festival: number}}
 */
export const GOODS_CATE_INFO = {
  /**
   * 商城普通商品
   */
  general: {
    id: 1, //类别编号
    code: "0001", //类别代码
    adsId: 36, //轮播图广告编号
    addToCart: true, //允许添加到购物车
    requireAddress: true, //必须填写收货地址信息
    name: "商城",
  },

  /**
   * 电影
   */
  movie: {
    id: 2,
    code: "0002",
    adsId: 0,
    addToCart: false,
    requireAddress: false,
    name: "电影",
  },

  /**
   * 蛋糕
   */
  cake: {
    id: 3,
    code: "0003",
    adsId: 0,
    addToCart: false,
    requireAddress: true,
    name: "蛋糕",
  },

  /**
   * 电子券(生日汇)
   */
  ticket: {
    id: 4,
    code: "0004",
    adsId: 44,
    addToCart: false,
    requireAddress: false,
    name: "电子券",
  },

  /**
   * 节日礼包
   */
  festival: {
    id: 5,
    code: "0005",
    adsId: 45,
    addToCart: false,
    requireAddress: true,
    name: "礼包",
  },

  /**
   * 演出
   */
  drama: {
    id: 6,
    code: "0006",
    adsId: 47,
    addToCart: false,
    requireAddress: false,
    name: "演出",
  },

  /**
   * 旅游
   */
  travel: {
    id: 7,
    code: "0007",
    adsId: 49,
    addToCart: false,
    requireAddress: false,
    name: "旅游",
  },

  /**
   * 图书
   */
  books: {
    id: 10,
    code: "0010",
    adsId: 46,
    addToCart: true,
    requireAddress: true,
    name: "图书",
  },

  life: {
    id: 9,
    code: "0009",
    adsId: 43,
    addToCart: false,
    requireAddress: false,
    name: "生活",
  },

  health: {
    id: 8,
    code: "0008",
    adsId: 48,
    addToCart: false,
    requireAddress: false,
    name: "健康",
  },

  shangchao: {
    id: 11,
    code: "0011",
    adsId: 50,
    addToCart: false,
    requireAddress: false,
    name: "商超",
  },

  topiclist: {
    id: 12,
    code: "0012",
    adsId: 48,
    addToCart: false,
    requireAddress: false,
    name: "专题",
  },

  duoxuan: {
    id: 13,
    code: "0013",
    adsId: 48,
    addToCart: false,
    requireAddress: false,
    name: "多选",
  },

  vegetable: {
    id: 14,
    code: "0014",
    adsId: 51,
    addToCart: false,
    requireAddress: false,
    name: "买菜",
  },

  video: {
    id: 15,
    code: "0015",
    adsId: 52,
    addToCart: false,
    requireAddress: false,
    name: "影音",
  },

  privilege: {
    id: 16,
    code: "0016",
    adsId: 52,
    addToCart: false,
    requireAddress: false,
    name: "特权",
  },

  birthday_privilege: {
    id: 17,
    code: "0017",
    adsId: 52,
    addToCart: false,
    requireAddress: false,
    name: "生日特权",
  },

  movie_other: {
    id: 18,
    code: "0018",
    adsId: 52,
    addToCart: false,
    requireAddress: false,
    name: "特惠商城",
  },

  // 餐饮
  food: {
    id: 19,
    code: "0019",
    adsId: 52,
    addToCart: false,
    requireAddress: false,
    name: "餐饮",
  },

  // 夏送清凉 冬送温暖
  // module-common-index created 有用到
  dswl: {
    id: 21,
    code: "0021",
    name: "夏送清凉",
  },
};

/**
 * 商城系统模块定义
 * @type {[{orderType: number, name: string, cateInfo: {code: string, addToCart: boolean, id: number, adsId: number}, tabBar: string, index: string, title: string}, {orderType: number, name: string, cateInfo: {code: string, addToCart: boolean, id: number, adsId: number}, tabBar: string, index: string, title: string}, {orderType: number, name: string, cateInfo: {code: string, addToCart: boolean, id: number, adsId: number}, tabBar: string, index: string, title: string}, {orderType: number, name: string, cateInfo: {code: string, addToCart: boolean, id: number, adsId: number}, tabBar: string, index: string, title: string}]}
 */
export const MallModules = [
  {
    indexNavFlag: 1,
    extNameV3: "特惠商城",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/lmm3vs7sbnmi2o9zfd2jr2vg.png",
    textColor: "#018DFF",
    topCateId: 18,
    cateCode: "0018",
    name: "movieOther",
    title: "特惠商城",
  },
  {
    indexNavFlag: 999,
    extNameV3: "餐  饮",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/e17t5ykjvo6xtuoch7ilrgwx.png",
    textColor: "#FF3F3C",
    topCateId: 19,
    cateCode: "0019",
    name: "food",
    title: "餐饮",
  },
  {
    indexNavFlag: 999,
    extNameV3: "特  权",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/d8g2ht2zium2u7quhuixapov.png",
    textColor: "#FF7402",
    topCateId: 16,
    cateCode: "0016",
    name: "privilege",
    title: "特权",
  },
  {
    indexNavFlag: 999,
    extNameV3: "生日特权",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/6e04fw2k5l5n1skcpf2pgyro.png",
    textColor: "#FF7402",
    topCateId: 17,
    cateCode: "0017",
    name: "birthdayPrivilege",
    title: "生日特权",
  },
  {
    headImage:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241209/asrbli5r4gi76zpvp02z98e3.png",
    indexNavFlag: 999,
    extNameV3: "专属定制",
    iconImgV3: "images/index-new/class/jieqing.png?t=222",
    textColor: "#FF7402",
    topCateId: 999,
  },
  {
    title: "商超",
    name: "supermarket",
    addToCart: false,
    topCateId: 11,
    extName: "商超/Supermarket",
    iconImg: "images/index-new/class/shangchangtubiao-.svg",
    indexNavFlag: 9,
    extNameV3: "商  超",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/ooans6fmwbrfkzvr92vdtbem.png",
    textColor: "#FF3F3C",
  },
  {
    title: "买菜",
    name: "vegetable",
    addToCart: false,
    topCateId: 14,
    extName: "买菜/Vegetable",
    iconImg: "images/index-new/class/shucaiqu.svg",
    indexNavFlag: 10,
    extNameV3: "买  菜",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/im9udag9skc4t85xb3uhybqt.png",
    textColor: "#16C1BF",
  },
  {
    title: "影音",
    name: "video",
    addToCart: false,
    topCateId: 15,
    extName: "影音/Video",
    iconImg: "images/index-new/class/yingyinyule.svg",
    indexNavFlag: 11,
    extNameV3: "影  音",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/7od6zjp7d35e7yfcmmjpv3id.png",
    textColor: "#16C1BF",
  },
  {
    title: "门票",
    name: "travel",
    index: "/travel",
    addToCart: false,
    topCateId: 7,
    extName: "门票/Ticket",
    iconImg: "images/index-new/class/a-02_menpiao.svg",
    extNameV3: "门  票",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/wur9cv196ceh9fo7x473lf98.png",
    indexNavFlag: 99,
    textColor: "#018DFF",
  },
  {
    title: "图书",
    name: "books",
    index: "/books",
    addToCart: true,
    topCateId: 10,
    extName: "图书/Book",
    iconImg: "images/index-new/class/tushu.svg",
    extNameV3: "图  书",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/0ac5smc4q9qkat6lvpfjwezu.png",
    indexNavFlag: 20,
    textColor: "#16C1BF",
  },
  {
    title: "生日汇",
    name: "birthday",
    index: "/birthday",
    addToCart: false,
    topCateId: 4,
  },
  {
    title: "节日礼包",
    name: "festival",
    index: "/festival",
    topCateId: 5,
    addToCart: false,
  },
  {
    title: "商城",
    name: "mall",
    index: "/",
    requireExpress: true,
    addToCart: true,
    topCateId: 1,

    //导航页显示设置
    extName: "商城/Mall", //导航页显示的名称
    iconImg: "images/index-new/class/shangcheng_1.svg", //导航页显示的图标
    extNameV3: "商  城", //导航页显示的名称
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/6zxe402l7wda4pjb7x1uxex0.png", //导航页显示的图标
    indexNavFlag: 5, //导航页显示>0,按这个数字排序
    textColor: "#FF3F3C",
  },
  {
    title: "电影",
    name: "movie",
    index: "/movie",
    topCateId: 2,
    addToCart: false,
    extName: "电影/Movie",
    iconImg: "images/index-new/class/dianying.svg",
    extNameV3: "电  影",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/r0ok4a2ym33ybekehvv96s3v.png",
    indexNavFlag: 6,
    textColor: "#018DFF",
  },
  {
    title: "演艺",
    name: "drama",
    index: "/drama",
    topCateId: 6,
    addToCart: false,
    extName: "演艺/Drama",
    iconImg: "images/index-new/class/xiaoyuanyanchu.svg",
    extNameV3: "演  艺",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/geuil6d3ga8jxi7ylh0b7bg0.png",
    indexNavFlag: 21,
    textColor: "#FF7C0E",
  },
  {
    title: "生活",
    name: "life",
    index: "/life",
    topCateId: 9,
    addToCart: false,
    extName: "生活/Life",
    iconImg: "images/index-new/class/shenghuofuwu.svg",
    extNameV3: "生  活",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/y7e9nt8vzywu76tv1ph5o4hc.png",
    indexNavFlag: 8,
    textColor: "#FF7402",
  },
  {
    title: "体检",
    name: "health",
    index: "/health",
    topCateId: 8,
    addToCart: false,
    extName: "体检/Health",
    iconImg: "images/index-new/class/tj.svg",
    extNameV3: "体  检",
    iconImgV3:
      "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250306/hon3ejocajwxazfvgd1kwdub.png",
    indexNavFlag: 100,
    textColor: "#018DFF",
  },
  {
    title: "在线点餐",
    name: "hw-h5",
    index: "/web/hw-h5",
    topCateId: 20, // 对应数据库里的ID 关系卡券使用范围配置
    addToCart: false,
    extName: "在线点餐",
    extNameV3: "在线点餐",
    iconImgV3: "images/index-new/class/zxdc.jpg",
    indexNavFlag: 9999, // 用于排序的
    textColor: "#018DFF",
  },
  {
    title: "夏送清凉", // 冬送温暖
    name: "dswl",
    cateCode: "0021",
    topCateId: 21, // 对应数据库里的ID 关系卡券使用范围配置
    textColor: "#018DFF",
    indexNavFlag: 9999, // 用于排序的
    extNameV3: "夏送清凉", // 冬送温暖
    iconImgV3: "images/index-new/class/dswl.jpg",
  },
];

/**
 * 卡券类型
 * @type {{MONEY: number, TIMES: number}}
 */
export const CARD_TYPE = {
  /**
   * 现金卡
   */
  MONEY: 1,
  /**
   * 次卡
   */
  TIMES: 2,
};
